import { getRulesRoute } from '../routes';
import useDarkLayout from '../../components/loyauts/use-dark-layout';
import './style.scss';
import NextLink from '../../components/next-link';
import imgMinisterstwo from '../../assets/footer/ministerstwo.jpg';
import imgCeo from '../../assets/footer/ceo.jpg';
import imgBiblioteka from '../../assets/footer/biblioteka.jpg';
import imgAbcxxi from '../../assets/footer/abcxxi.jpg';
import imgFrsi from '../../assets/footer/frsi.jpg';
import imgPlaton from '../../assets/footer/platon.jpg';


export default function HomePage() {

    useDarkLayout();

    return <>
        <header>
            <h1>Gra na noc bibliotek 2021</h1>
        </header>
        <main>
            <div className="page-box home-page">
                <div className="page-box-content">
                    <h2>Witajcie!</h2>
                    <p>Mamy przyjemność zaprosić Was do udziału w drugiej edycji gry online, przygotowanej na Noc Bibliotek 2021 r. Podejmijcie wyzwanie, zmierzcie się z zadaniami i sprawdźcie, czy „Czytanie wzmacnia”!</p>
                    <p>Tegoroczna edycja gry składa się z czterech ścieżek: zdrowia, relacji, wiedzy i wyobraźni. Dzięki różnorodnym zadaniom, dotyczącym m.in. literatury, książek czy waszej biblioteki zobaczycie, jak czytanie wzmacnia różne dziedziny życia! Przejście całej gry trwa ok. 2 godzin, ale można dzielić ją na części i wracać w dogodnym momencie.</p>
                    <p>Zaczynamy Noc Bibliotek 2021!</p>
                </div>
            </div>
            <div className="post-page-box-links">
                <NextLink to={getRulesRoute()}>Dalej</NextLink>
            </div>
        </main>
        <footer className='page-footer'>
            <div className="page-footer-inner">
                <div className="footer-grid">
                    <div className="text main">
                        <h3>Główny organizator</h3>
                    </div>
                    <div className="logos main">
                        <div className="logos-wrapper">
                            <a href="https://ceo.org.pl/"><img src={imgCeo} alt="" /></a>
                        </div>
                    </div>
                    <div className="text ministerstwo">
                        <h3>Dofinansowano ze środków Ministra Kultury, Dziedzictwa Narodowego i Sportu pochodzących z Funduszu Promocji Kultury</h3>
                    </div>
                    <div className="logos ministerstwo">
                        <div className="logos-wrapper">
                            <a href="https://www.gov.pl/web/kulturaisport"><img src={imgMinisterstwo} alt="Ministerstwo Kultury, Dziedzictwa Narodowego i Sportu" /></a>
                        </div>
                    </div>
                    <div className="text patron">
                        <h3>Patron honorowy</h3>

                    </div>
                    <div className="logos patron">
                        <div className="logos-wrapper">
                            <a href="https://www.bn.org.pl/"><img src={imgBiblioteka} alt="" /></a>
                        </div>
                    </div>
                    <div className="text organizer">
                        <h3>Współorganizatorzy</h3>
                    </div>
                    <div className="logos organizer">
                        <div className="logos-wrapper">
                            <a href="https://calapolskaczytadzieciom.pl/"><img src={imgAbcxxi} alt="" /></a>
                            <a href="https://frsi.org.pl/"><img src={imgFrsi} alt="" /></a>
                        </div>
                    </div>
                    <div className="text mecenas">
                        <h3>Mecenas akcji</h3>
                    </div>
                    <div className="logos mecenas">
                        <div className="logos-wrapper">
                            <a href="https://www.platon.com.pl/"><img src={imgPlaton} alt="" /></a>
                        </div>
                    </div>

                </div>

            </div>
        </footer>
    </>
}
